import { render, staticRenderFns } from "./FPADialog.vue?vue&type=template&id=0bc84a57&scoped=true"
import script from "./FPADialog.vue?vue&type=script&lang=js"
export * from "./FPADialog.vue?vue&type=script&lang=js"
import style0 from "./FPADialog.vue?vue&type=style&index=0&id=0bc84a57&scoped=true&lang=css"
import style1 from "./FPADialog.vue?vue&type=style&index=1&id=0bc84a57&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc84a57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc84a57')) {
      api.createRecord('0bc84a57', component.options)
    } else {
      api.reload('0bc84a57', component.options)
    }
    module.hot.accept("./FPADialog.vue?vue&type=template&id=0bc84a57&scoped=true", function () {
      api.rerender('0bc84a57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/FPADialog.vue"
export default component.exports